<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户名称" prop="nickname" >
        <a-input disabled v-model="form.nickname" placeholder="请输入用户" />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="mobile" >
        <a-input disabled v-model="form.mobile" placeholder="请输入联系电话" />
      </a-form-model-item>
      <a-form-model-item label="注销原因" prop="reason" >
        <a-input disabled v-model="form.reason" placeholder="请输入注销原因" />
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="status" >
        <a-select :disabled="isInfo == true" v-model="form.status">
          <a-select-option :value="1">待审核</a-select-option>
          <a-select-option :value="2">通过</a-select-option>
          <a-select-option :value="3">驳回</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="failReason" v-if="form.status == 3">
        <a-input :disabled="isInfo == true" v-model="form.failReason" placeholder="请输入驳回原因" />
      </a-form-model-item>
      <a-form-model-item label="审核人" prop="examineName" v-if="form.examineName">
        <a-input disabled v-model="form.examineName" placeholder="请输入审核人" />
      </a-form-model-item>
      <a-form-model-item label="审核时间" prop="examineTime" >
        <a-date-picker disabled style="width: 100%" v-model="form.examineTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="isInfo == false" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCancel, addCancel, checkCancel } from '@/api/user/cancel'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:false,
      // 表单参数
      form: {
        id: null,
        userId: null,
        nickname:null,
        mobile: null,
        reason: null,
        status: 0,
        failReason: null,
        examineName: null,
        examineTime: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: '审核状态不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.isInfo = false
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        nickname:null,
        mobile: null,
        reason: null,
        status: 0,
        failReason: null,
        examineName: null,
        examineTime: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCancel({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleInfo (row) {
      this.reset()
      getCancel({id:row.id}).then(response => {
        this.form = response.data
        this.open = true
        this.isInfo = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            checkCancel({id:this.form.id,status:this.form.status,failReason:this.form.failReason}).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCancel(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
